module.exports = __webpack_public_path__ + "static/media/au.da96b2e8.svg";